<template lang="pug">
    .container.mx-auto.spacingTopStandard.spacingBottomStandard
      table.table.table-auto
        tbody
          tr
            th(width='58') Position
            th(width='607') Wein
            th(width='83') Durchschn. Preis (US-$)
            th(width='80') Maxim. Preis (US-$)
          tr
            td 1
            td Domaine de la Romanee Conti Romanee Conti, Frankreich
            td(width='83') 10,777
            td(width='80') 64,703
          tr
            td 2
            td Domaine Leflaive Montrachet, Frankreich
            td(width='83') 6,453
            td(width='80') 11,388
          tr
            td 3
            td Henri Jayer Cros Parantoux, Vosne Romanee, Frankreich
            td(width='83') 6,013
            td(width='80') 16,688
          tr
            td 4
            td Domaine de la Romanee Conti Montrachet, Frankreich
            td(width='83') 4,092
            td(width='80') 13,062
          tr
            td 5
            td Domaine Leroy Musigny, Frankreich
            td(width='83') 3,591
            td(width='80') 14,378
          tr
            td 6
            td Domaine Georges Roumier Musigny, Frankreich
            td(width='83') 3,252
            td(width='80') 13,688
          tr
            td 7
            td Georges et Henri Jayer Echezeaux, Frankreich
            td(width='83') 3,072
            td(width='80') 8,800
          tr
            td 8
            td Chateau Petrus, Frankreich
            td(width='83') 2,963
            td(width='80') 42,862
          tr
            td 9
            td Screaming Eagle Cabernet Sauvignon, USA
            td(width='83') 2,646
            td(width='80') 19,483
          tr
            td 10
            td Domaine de la Romanee Conti La Tache, Frankreich
            td(width='83') 2,493
            td(width='80') 18,985
          tr
            td 11
            td Domaine Leroy Chambertin, Frankreich
            td(width='83') 2,464
            td(width='80') 5,778
          tr
            td 12
            td Chateau Le Pin, Frankreich
            td(width='83') 2,451
            td(width='80') 13,757
          tr
            td 13
            td Domaine Faiveley Musigny, Frankreich
            td(width='83') 2,06
            td(width='80') 5,670
          tr
            td 14
            td J. F. Coche Dury Corton Charlemagne, Frankreich
            td(width='83') 2,018
            td(width='80') 5,778
          tr
            td 15
            td Bernard Dugat Py Chambertin, Frankreich
            td(width='83') 1,906
            td(width='80') 4,746
          tr
            td 16
            td Domaine Leroy Richebourg, Frankreich
            td(width='83') 1,818
            td(width='80') 7,139
          tr
            td 17
            td Seppeltsfield Para Centenary 100 Year Old Vintage Tawny, Australien
            td(width='83') 1,784
            td(width='80') 2,028
          tr
            td 18
            td Chateau Lafite Rothschild, Frankreich
            td(width='83') 1,663
            td(width='80') 291,170
          tr
            td 19
            td Domaine des Comtes Lafon Montrachet, Frankreich
            td(width='83') 1,593
            td(width='80') 4,655
          tr
            td 20
            td Domaine Georges Roumier Les Amoureuses, Chambolle Musigny, Frankreich
            td(width='83') 1,551
            td(width='80') 9,409
          tr
            td 21
            td Domaine de la Romanee Conti Richebourg, Frankreich
            td(width='83') 1,538
            td(width='80') 10,333
          tr
            td 22
            td Domaine Leroy Clos de la Roche, Frankreich
            td(width='83') 1,436
            td(width='80') 6,995
          tr
            td 23
            td Domaine Ramonet Montrachet, Frankreich
            td(width='83') 1,338
            td(width='80') 5,825
          tr
            td 24
            td Domaine Leroy Romanee Saint Vivant, Frankreich
            td(width='83') 1,298
            td(width='80') 3,760
          tr
            td 25
            td J. F. Coche Dury Les Perrieres, Meursault, Frankreich
            td(width='83') 1,286
            td(width='80') 3,601
          tr
            td 26
            td Champagne Krug Clos du Mesnil Brut Blanc de Blancs, Frankreich
            td(width='83') 1,195
            td(width='80') 5,700
          tr
            td 27
            td Chateau Lafleur, Frankreich
            td(width='83') 1,105
            td(width='80') 14,854
          tr
            td 28
            td Domaine de la Romanee Conti Romanee Saint Vivant, Frankreich
            td(width='83') 1,097
            td(width='80') 9,892
          tr
            td 29
            td Chateau Ausone, Frankreich
            td(width='83') 1,045
            td(width='80') 30,000
          tr
            td 30
            td Domaine de la Romanee Conti Grands Echezeaux, Frankreich
            td(width='83') 1,036
            td(width='80') 6,200
          tr
            td 31
            td Champagne Krug Collection Brut, Frankreich
            td(width='83') 1,020
            td(width='80') 8,426
          tr
            td 32
            td Quinta do Noval Nacional Vintage Port, Portugal
            td(width='83') 1,011
            td(width='80') 7,348
          tr
            td 33
            td Domaine Leroy Latricieres Chambertin, Gevrey Chambertin, Frankreich
            td(width='83') 1,009
            td(width='80') 2,749
          tr
            td 34
            td Chateau Latour, Frankreich
            td(width='83') 989
            td(width='80') 26,764
          tr
            td 35
            td Domaine Leroy Clos de Vougeot, Frankreich
            td(width='83') 954
            td(width='80') 3,257
          tr
            td 36
            td Robert Weil Kiedricher Grafenberg Riesling Trockenbeerenauslese, Deutschland
            td(width='83') 910
            td(width='80') 1,958
          tr
            td 37
            td Dominio de Pingus, Spanien
            td(width='83') 907
            td(width='80') 12,105
          tr
            td 38
            td R Wines Chris Ringland Three Rivers Dry Grown Shiraz, Australien
            td(width='83') 842
            td(width='80') 2,144
          tr
            td 39
            td Chateau Margaux, Frankreich
            td(width='83') 835
            td(width='80') 19,518
          tr
            td 40
            td Domaine Leroy Corton Renardes, Frankreich
            td(width='83') 835
            td(width='80') 3,178
          tr
            td 41
            td Domaine de la Romanee Conti Echezeaux, Frankreich
            td(width='83') 830
            td(width='80') 6,200
          tr
            td 42
            td Emmanuel Rouget Cros Parantoux, Vosne Romanee, Frankreich
            td(width='83') 816
            td(width='80') 1,941
          tr
            td 43
            td Domaine Armand Rousseau Pere et Fils Chambertin, Frankreich
            td(width='83') 805
            td(width='80') 9,409
          tr
            td 44
            td Champagne Bollinger Vieilles Vignes Francaises Blanc de Noirs, Frankreich
            td(width='83') 798
            td(width='80') 2,538
          tr
            td 45
            td Chateau Cheval Blanc, Frankreich
            td(width='83') 792
            td(width='80') 33,974
          tr
            td 46
            td Domaine Armand Rousseau Pere et Fils Chambertin Clos de Beze, Frankreich
            td(width='83') 780
            td(width='80') 3,796
          tr
            td 47
            td Harlan Estate, USA
            td(width='83') 777
            td(width='80') 3,319
          tr
            td 48
            td Domaine Comte Georges de Vogue Musigny Cuvee Vieilles Vignes, Frankreich
            td(width='83') 774
            td(width='80') 9,058
          tr
            td 49
            td Claude Dugat Griottes Chambertin, Frankreich
            td(width='83') 762
            td(width='80') 3,109
          tr
            td 50
            td Domaine Meo Camuzet Au Cros Parantoux, Vosne Romanee, Frankreich
            td(width='83') 759
            td(width='80') 2,028

</template>

<script>
export default {
    name: 'Table2'
    // Die teuersten Weine der Welt
};
</script>

<style lang="sass" scoped>
.table
  @apply table w-full

  tr:nth-child(odd)
    @apply bg-gray-100

  &:first-child
    td
    @apply border-t
  td, th
    @apply border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
